import { render, staticRenderFns } from "./credit-notes.vue?vue&type=template&id=4752deb0"
import script from "./credit-notes.vue?vue&type=script&lang=js"
export * from "./credit-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports